import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateIndexComponent } from './create-index.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: CreateIndexComponent,
        data: {
          title: "Yaratish",
          breadcrumb: "Yaratish"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CreateIndexRoutingModule { }
